// Author popup for the ungated variant work card
export const setUpAuthorPopup = (): void => {
  // Initialize avatar hover tooltips using Popover API
  // Progressive enhancement: Use CSS Anchor Positioning if supported, otherwise fall back to JS positioning
  const avatars = document.querySelectorAll(
    '.ungated-work-card--author-avatar[data-tooltip-id]',
  );

  // Feature detect CSS Anchor Positioning support
  const supportsAnchorPositioning = CSS.supports('anchor-name', '--test');

  avatars.forEach((avatar) => {
    const tooltipId = avatar.getAttribute('data-tooltip-id');
    if (!tooltipId) return;

    const tooltip = document.getElementById(tooltipId) as HTMLElement & {
      showPopover?: () => void;
      hidePopover?: () => void;
    };
    if (!tooltip) return;

    if (supportsAnchorPositioning) {
      // Modern browsers: CSS handles positioning, just show/hide the popover
      avatar.addEventListener('mouseenter', () => {
        if (tooltip.showPopover) {
          tooltip.showPopover();
        }
      });

      avatar.addEventListener('mouseleave', () => {
        if (tooltip.hidePopover) {
          tooltip.hidePopover();
        }
      });
    } else {
      // Fallback for older browsers: position with JavaScript
      const positionTooltip = (): void => {
        const avatarRect = (avatar as HTMLElement).getBoundingClientRect();
        tooltip.style.position = 'fixed';
        tooltip.style.left = `${avatarRect.left + avatarRect.width / 2}px`;
        tooltip.style.top = `${avatarRect.bottom + 8}px`;
        tooltip.style.transform = 'translateX(-50%)';
        tooltip.style.zIndex = '1000';
      };

      avatar.addEventListener('mouseenter', () => {
        if (tooltip.showPopover) {
          tooltip.showPopover();
          positionTooltip();
        }
      });

      avatar.addEventListener('mouseleave', () => {
        if (tooltip.hidePopover) {
          tooltip.hidePopover();
        }
      });
    }
  });

  // Make +N avatar clickable to open the details popup
  const overflowAvatar = document.querySelector(
    '.ungated-work-card--author-avatar-overflow',
  );
  const details = document.querySelector(
    '.ungated-work-card--author-details',
  ) as HTMLDetailsElement | null;

  if (overflowAvatar && details) {
    overflowAvatar.addEventListener('click', () => {
      details.open = true;
    });
  }

  // Existing popup click-outside logic
  if (!details) return;

  const summary = details.querySelector('summary');

  // Handles closing when clicking outside of the popup
  const handleClickOutside = (event: MouseEvent): void => {
    const target = event.target as Node;
    if (summary?.contains(target) || details.contains(target)) {
      return;
    }
    details.open = false;
  };

  // Only attach the click listener when the popup is open
  details.addEventListener('toggle', () => {
    if (details.open) {
      document.addEventListener('click', handleClickOutside);
    } else {
      document.removeEventListener('click', handleClickOutside);
    }
  });
};
